/** @jsx jsx */
import { jsx, css } from '@emotion/core'

import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  path {
    &.fill {
      fill: ${theme.color.modalTxt};
    }
  }
`

export default function BetIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="48.708" viewBox="0 0 80 48.708" css={Color}>
      <g id="그룹_7150" data-name="그룹 7150" transform="translate(-65 -184.002)">
        <rect id="사각형_4831" className="fill" data-name="사각형 4831" width="3.6" height="12.995" transform="translate(118.537 184.031)" fill="#141414"/>
        <rect id="사각형_4832" className="fill" data-name="사각형 4832" width="3.6" height="12.995" transform="translate(118.537 201.864)" fill="#141414"/>
        <rect id="사각형_4833" className="fill" data-name="사각형 4833" width="3.6" height="12.995" transform="translate(118.537 219.701)" fill="#141414"/>
        <path id="패스_81" className="fill" data-name="패스 81" d="M827.56,360.564a1.014,1.014,0,0,0,1.019.974h8.3c5.774,0,10.139-2.3,10.153-7.263a5.689,5.689,0,0,0-4.9-5.85v-.167a5.589,5.589,0,0,0,3.572-5.336c0-4.612-4.077-6.083-9.443-6.1h-7.6a1.014,1.014,0,0,0-1.019.963h0Zm5.245-13.676v-6.261h3.1c3.13,0,4.7.873,4.689,3.043,0,1.969-1.454,3.235-4.769,3.228Zm-.017,10.856v-7.2h3.637c3.6,0,5.506,1.009,5.5,3.419,0,2.567-1.951,3.774-5.51,3.77Z" transform="translate(-742.613 -140.484)" fill="#141414"/>
        <path id="패스_5261" className="fill" data-name="패스 5261" d="M882.048,324.486v3.476a2.086,2.086,0,0,1,2.087,2.031v6.647a12.287,12.287,0,0,0-6.226,2.5h-.031l-.421.365-.136.115-.129.059-.323.337a11.415,11.415,0,0,0-3.906,8.842,11.214,11.214,0,0,0,3.84,8.7,12.309,12.309,0,0,0,7.283,3.478v6.63A2.07,2.07,0,0,1,882,369.715h-13.77V369.7H816.1a5.011,5.011,0,0,1-5.005-4.984v-31.77a5.025,5.025,0,0,1,5.044-4.985h65.9l.013-3.476m0,0H816.1a8.484,8.484,0,0,0-8.483,8.443v31.788a8.484,8.484,0,0,0,8.483,8.463H864.75v.014h17.28a5.535,5.535,0,0,0,5.537-5.51v-8.348a1.84,1.84,0,0,0-.522-1.217,2.089,2.089,0,0,0-1.322-.487h-.3a8.744,8.744,0,0,1-6.24-2.619,7.8,7.8,0,0,1-2.737-6.15,7.98,7.98,0,0,1,2.737-6.24c.031,0,.031-.031.08-.052a8.912,8.912,0,0,1,6.219-2.525h.257a2.1,2.1,0,0,0,1.322-.487,1.8,1.8,0,0,0,.552-1.218v-8.347A5.565,5.565,0,0,0,882.048,324.486Z" transform="translate(-742.613 -140.484)" fill="#141414"/>
      </g>
    </svg>
  )
}
